import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort'
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({

  imports: [MatButtonModule, MatCheckboxModule, MatTableModule, MatPaginatorModule, MatFormFieldModule,
    MatInputModule, MatSortModule, MatCardModule, MatMenuModule,MatProgressSpinnerModule, MatDatepickerModule,
    MatAutocompleteModule, MatSelectModule, MatSnackBarModule, MatDialogModule],

  exports: [MatButtonModule, MatCheckboxModule, MatTableModule, MatPaginatorModule, MatFormFieldModule,
    MatInputModule, MatSortModule, MatCardModule, MatMenuModule,MatProgressSpinnerModule, MatDatepickerModule,
    MatAutocompleteModule, MatSelectModule, MatSnackBarModule, MatDialogModule],
})
export class AngularMaterialModule { }
